export default class FactureAvoirUpdateController {

    static $inject = [
        '$scope',
        '$stateParams',
        '$state',
        'AvoirsService',
        'TicketsService',
        'FacturesService',
        'notification',
        'ModalService',
        '$uibModal',
        'moment',
        '$translate',
        '$filter',
        '_'
    ];

    constructor($scope, $stateParams, $state, AvoirsService, TicketsService, FacturesService, notification, ModalService, $uibModal, moment, $translate, $filter, _) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.AvoirsService = AvoirsService;
        this.TicketsService = TicketsService;
        this.FacturesService = FacturesService;
        this.notification = notification;
        this.ModalService = ModalService;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.$translate = $translate;
        this.$filter = $filter;
        this._ = _;
    }

    async $onInit() {
        this.isEnabledProduit = true;
        await this.getElementsSelectionnables();
        await this.getZones();
        this.isMonoTicket = false;
        if (this.tickets.length == 1) {
            this.isMonoTicket = true;
        }
        this.isDeleteTransporteur = '0';
        this.isDeleteChantier = '0';
        this.isDeleteTransporteur = '0';
        this.isDeleteLieu = '0';
        this.isDeleteReference = '0';
        this.isDeleteChauffeur = '0';
        this.isDeleteZone = '0';
        this.isDeleteCommande = '0';
        this.isNonFacturable = '0';
        this.isTransportFacturer = '0';
        this.isTransportFranco = '0';
        this.isCessionInterne = '0';
        this.isProduitEnabled();
        this.getInitInput();
    }

    getInitInput() {
        if (this.isMonoTicket) {
            if (this.tickets[0].update.idChantier) {
                this.chantier = {
                    id: this.tickets[0].update.idChantier,
                    libelle: this.tickets[0].update.libelleChantier
                }
            }
            if (this.tickets[0].update.isDeleteChantier) {
                this.isDeleteChantier = '1';
            }
            this.referenceClient = this.tickets[0].update.referenceClient;
            if (this.tickets[0].update.isDeleteReference) {
                this.isDeleteReference = '1';
            }
            if (this.tickets[0].update.idTransporteur) {
                this.transporteur = {
                    id: this.tickets[0].update.idTransporteur,
                    libelle: this.tickets[0].update.libelleTransporteur
                }
            }
            if (this.tickets[0].update.isDeleteTransporteur) {
                this.isDeleteTransporteur = '1';
            }
            if (this.tickets[0].update.idLieu) {
                this.lieu = {
                    id: this.tickets[0].update.idLieu,
                    libelle: this.tickets[0].update.libelleLieu
                }
            }
            if (this.tickets[0].update.isDeleteLieu) {
                this.isDeleteLieu = '1';
            }
            if (this.tickets[0].update.idChauffeur) {
                this.chauffeur = {
                    id: this.tickets[0].update.idChauffeur,
                    nomPrenom: this.tickets[0].update.libelleChauffeur
                }
            }
            if (this.tickets[0].update.isDeleteChauffeur) {
                this.isDeleteChauffeur = '1';
            }
            if (this.tickets[0].update.idZone) {
                this.zone = {
                    id: this.tickets[0].update.idZone,
                    libelle: this.tickets[0].update.libelleZone
                }
            }
            if (this.tickets[0].update.isDeleteZone) {
                this.isDeleteZone = '1';
            }
            if (this.tickets[0].update.idCommande) {
                this.commande = {
                    id: this.tickets[0].update.idCommande,
                    codeLibelle: this.tickets[0].update.libelleCommande
                }
            }
            if (this.tickets[0].update.isDeleteCommande) {
                this.isDeleteCommande = '1';
            }

            this.isTransportFacturer = this.tickets[0].update.isTransportFacturer == true ? '1' : this.tickets[0].update.isTransportFacturer == false ? '2' : '0';  
            this.isNonFacturable = this.tickets[0].update.isNonFacturable == true ? '1' : this.tickets[0].update.isNonFacturable == false ? '2' : '0';
            this.isTransportFranco = this.tickets[0].update.isFranco == true ? '1' : this.tickets[0].update.isFranco == false ? '2' : '0';
            this.isCessionInterne = this.tickets[0].update.isCessionInterne == true ? '1' : this.tickets[0].update.isCessionInterne == false ? '2' : '0';

            this.quantite = this.tickets[0].update.quantite;
            let filtre = this._.find(this.produitsLies, {produitId:this.tickets[0].update.idProduit, producteurId: this.tickets[0].update.idProducteur});
            if (filtre)
                filtre.selected = true;
        }
    }

    resetInput() {
        this.isDeleteChantier = '0';
        this.isDeleteTransporteur = '0';
        this.isDeleteLieu = '0';
        this.isDeleteReference = '0';
        this.isDeleteChauffeur = '0';
        this.isDeleteZone = '0';
        this.isDeleteCommande = '0';
        this.isNonFacturable = '0';
        this.isTransportFacturer = '0';
        this.isTransportFranco = '0';
        this.isCessionInterne = '0';
        this.chantier = null;
        this.referenceClient = null;
        this.transporteur = null;
        this.lieu = null;
        this.chauffeur = null;
        this.zone = null;
        this.commande = null;
        this.quantite = null;
    }

    async reset() {
        await this.AvoirsService.resetTicket(this.tickets[0]);
        this.tickets[0].isUpdate = false;
        this.tickets[0].update = {};
        this.resetInput();
        this.modalInstance.close(true);
    }

    isProduitEnabled() {
        let response = true;
        this.isEnabledProduit = true;

        this.tickets.forEach(function (element) {
            if (element.idTicketProduits.length > 1) {
                response = false;
                this.isEnabledProduit = false;
                return false;
            }
        }, this);
        return response;
    }

    async getElementsSelectionnables() {
        let chantierId = this.chantier ? this.chantier.id : null;
        if (chantierId == null) {
            let idChantiers = [...new Set(this.tickets.map((item) => item.idChantier))];
            if (idChantiers.length == 1) {
                chantierId = idChantiers[0];
            }
        }

        var filtre = {
            societeId: null,
            siteCommercialId: this.idSite,
            clientId: this.idClient,
            chantierId: chantierId,
            entreeSortie: null,
            achatVente: 1
        };
        try {
            this.produitsLiesListe = await this.TicketsService.getProduitsLies(filtre);
            this.produitsLies = await this.prepareListeElementsLies(this.produitsLiesListe);
        } catch (err) {
            if (err.data) this.notification.error(err.data);
            else throw err;
        }
    }

    async prepareListeElementsLies(elementsATraiter) {
        var elementsSelectionnablesOrdonnes = this.$filter('orderBy')(elementsATraiter, 'producteurLibelle');
        var tmp = null;
        var temp = [];
        for (var index = 0; index < elementsSelectionnablesOrdonnes.length; index++) {
            var currentValue = elementsSelectionnablesOrdonnes[index];
            var toReturn = [];

            if (currentValue.hasOwnProperty('modeDeclenchement')) {
                currentValue.idComposant = currentValue.id;
                toReturn.push(currentValue);
            } else {
                //#region Gestion des groupes
                if (tmp == null) {
                    //creation du premier groupe
                    tmp = currentValue.producteurId;
                    toReturn.push({ libelle: '<span="font-weight:bold">' + currentValue.producteurLibelle + '</span>', msGroup: true });
                } else {
                    if (tmp != currentValue.producteurId) {
                        //création des autres groupes
                        toReturn.push({ msGroup: false });
                        tmp = currentValue.producteurId;
                        toReturn.push({ libelle: '<span="font-weight:bold">' + currentValue.producteurLibelle + '</span>', msGroup: true });
                    }
                }
                //#endregion
                currentValue.libelle = currentValue.produitCode + ' - ' + currentValue.produitLibelle;
                currentValue.valeur = false;
                currentValue.idComposant = currentValue.produitId;
                currentValue.code = currentValue.produitCode;
                currentValue.IdProducteur = currentValue.producteurId;
                toReturn.push(currentValue);

                if (index == elementsSelectionnablesOrdonnes.length - 1) {
                    toReturn.push({ msGroup: false });
                }
            }
            temp.push(toReturn);
        }
        var sorties = _.flatten(temp);
        return new Promise((resolve) => resolve(sorties));
    }

    change() {
        this.idProduit = this.produit[0].produitId;
        this.idProducteur = this.produit[0].producteurId;
    }

    async getClients(valeur) {
        let clients = await this.TicketsService.getClients(valeur);
        return clients;
    }

    changeClient() {
        this.chantier = null;
    }
    
    async getChantiers(valeur) {
        let idClient = this.idClient;
        if (this.client) {
            idClient = this.client.id;
        }
        let chantiers = await this.TicketsService.getChantiers(valeur, idClient, false);
        return chantiers;
    }

    async getTransporteurs(valeur) {
        let transporteurs = await this.TicketsService.getTransporteurs(valeur);
        return transporteurs;
    }

    async selectTransporteur() {
        this.chauffeur = null;
    }

    async getLieux(valeur) {
        let lieux = await this.TicketsService.getLieux(valeur);
        return lieux;
    }

    async getChauffeursRemplace(valeur) {
        let transporteurId = this.transporteur ? this.transporteur.id : null;
        let chauffeurs = await this.TicketsService.getChauffeursRemplace(valeur, transporteurId);
        return chauffeurs;
    }

    async getZones() {
        this.zones = await this.TicketsService.getZones(this.idSite);
    }

    async getCommandes(valeur) {
        let clientId = this.idClient;
        let chantierId = this.chantier ? this.chantier.id : null;

        if (chantierId == null) {
            let idChantiers = [...new Set(this.tickets.map((item) => item.idChantier))];
            if (idChantiers.length == 1) {
                chantierId = idChantiers[0];
            }
        }

        let commandes = await this.TicketsService.getCommandes(valeur, this.date, clientId, chantierId);
        return commandes;
    }

    async getNomClientDivers(valeur) {
        try {
            var res = await this.FacturesService.getNomClientDivers(valeur, this.idSociete);
            return res;
        } catch (ex) {
            this.notification.error(ex.data);
        }
    }

    annuler() {
        this.modalInstance.close(false);
    }

    valider() {
        if (this.isDelete) {
            if (!this.client) {                
                return;
            }
            this.tickets.forEach(function (ticket) {
                if (this.client.isGenerique) {
                    if (!this.clientDivers) {
                        ticket.isOk = false;
                        return;
                    }
                    else {
                        if (this.idClient != this.client.id || this.idClientDivers != this.clientDivers.id) {
                            ticket.isOk = true;
                        }
                        else {
                            ticket.isOk = false;
                            return;
                        }
                    }
                }
                else {
                    if (this.idClient != this.client.id) {
                        ticket.isOk = true;
                    }
                    else {
                        ticket.isOk = false;
                    }
                }

                if (this.client) {
                    ticket.deleteOption.idClient = this.client.id;
                    ticket.client = this.client.libelle;
                }
                if (this.clientDivers) {
                    ticket.deleteOption.idClientDivers = this.clientDivers.id;
                }
                if (this.isDeleteChantier == '1') {
                    ticket.deleteOption.isDeleteChantier = true;
                }
                else {
                    if (this.chantier) {
                        ticket.deleteOption.idChantier = this.chantier.id;
                        ticket.chantier = this.chantier.libelle;
                    }
                }
            }, this);
        }
        else {
            this.tickets.forEach(function (ticket) {
                let ticketUpdated = false;

                if (this.isDeleteChantier == '1') {
                    ticket.update.isDeleteChantier = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteChantier = false;
                    if (this.chantier) {
                        ticket.update.idChantier = this.chantier.id;
                        ticket.update.libelleChantier = this.chantier.libelle;
                        ticket.chantier = this.chantier.libelle;
                        ticketUpdated = true;
                    }
                }
                if (this.isDeleteReference == '1') {
                    ticket.update.isDeleteReference = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteReference = false;
                    if (this.referenceClient) {
                        ticket.update.referenceClient = this.referenceClient;
                        ticketUpdated = true;
                    }
                }
                if (this.isDeleteTransporteur == '1') {
                    ticket.update.isDeleteTransporteur = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteTransporteur = false;
                    if (this.transporteur) {
                        ticket.update.idTransporteur = this.transporteur.id;
                        ticket.update.libelleTransporteur = this.transporteur.libelle;
                        ticketUpdated = true;
                    }
                }
                if (this.isDeleteLieu == '1') {
                    ticket.update.isDeleteLieu = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteLieu = false;
                    if (this.lieu) {
                        ticket.update.idLieu = this.lieu.id;
                        ticket.update.libelleLieu = this.lieu.libelle;
                        ticketUpdated = true;
                    }
                }
                if (this.isDeleteChauffeur == '1') {
                    ticket.update.isDeleteChauffeur = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteChauffeur = false;
                    if (this.chauffeur)
                    {
                        ticket.update.idChauffeur = this.chauffeur.id;
                        ticket.update.libelleChauffeur = this.chauffeur.nomPrenom;
                        ticketUpdated = true;
                    }
                }
                if (this.isDeleteZone == '1') {
                    ticket.update.isDeleteZone = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteZone = false;
                    if (this.zone) {
                        ticket.update.idZone = this.zone.id;
                        ticket.update.libelleZone = this.zone.libelle;
                        ticketUpdated = true;
                    }          
                }
                if (this.isDeleteCommande == '1') {
                    ticket.update.isDeleteCommande = true;
                    ticketUpdated = true;
                }
                else {
                    ticket.update.isDeleteCommande = false;
                    if (this.commande) {
                        ticket.update.idCommande = this.commande.id;
                        ticket.update.libelleCommande = this.commande.codeLibelle;
                        ticketUpdated = true;
                    }
                }

                ticket.update.isTransportFacturer = this.isTransportFacturer == '0' ? null : this.isTransportFacturer == '1' ? true : false;
                ticket.update.isNonFacturable = this.isNonFacturable == '0' ? null : this.isNonFacturable == '1' ? true : false;
                ticket.update.isFranco = this.isTransportFranco == '0' ? null : this.isTransportFranco == '1' ? true : false;
                ticket.update.isCessionInterne = this.isCessionInterne == '0' ? null : this.isCessionInterne == '1' ? true : false;

                if(this.isTransportFacturer != '0' || this.isNonFacturable != '0' || this.isTransportFranco != '0' || this.isCessionInterne != '0') {
                    ticketUpdated = true;
                }

                if (this.quantite) {
                    ticket.update.quantite = this.quantite;
                    ticketUpdated = true;
                }

                if (this.produit.length > 0) {
                    let produitSelected = this.produit[0];
                    ticket.update.idProduit = produitSelected.produitId;
                    ticket.update.idProducteur = produitSelected.producteurId;
                    ticketUpdated = true;
                }

                ticket.isUpdate = ticketUpdated;
            }, this);
        }

        this.modalInstance.close(true);
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
